import { render, staticRenderFns } from "./TransferCharacters.vue?vue&type=template&id=726a5064&"
import script from "./TransferCharacters.vue?vue&type=script&lang=js&"
export * from "./TransferCharacters.vue?vue&type=script&lang=js&"
import style0 from "./TransferCharacters.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports